import { Component, OnInit, DoCheck } from '@angular/core';
import { AuthenticationService, AlertService } from 'src/app/shared/_services';
import { DatePipe, Location } from '@angular/common';
import { Platform } from '@ionic/angular';
import { CloseOverlayService } from '../../_services/closeOverlay.service';
import { CashiersStore, DashboardStore, TransactionsStore } from '../../_services/store';

@Component({
  selector: 'app-filter-transactions',
  templateUrl: './filter-transactions.page.html',
  styleUrls: ['./filter-transactions.page.scss'],
  providers: [DatePipe],
})
export class FilterTransactionsPage implements OnInit, DoCheck {
  today = Date.now();
  epochDateTime = new Date().getTime();
  todayDate: string;
  pickerDate: string;
  queryString: string;
  transactionStatus: string;
  paymentMethod: string;
  cashierId: any;
  offset: any;
  bankTransferCount: any;
  ussdCount: any;
  bankTransferCountArray: any = [];
  ussdCountArray: any = [];
  filterParams = [];
  transactionDetails = [];
  currentUser: any;
  subscription: any;
  cashiers: [] = this.cashiersStore.getCashiers();
  transactionCount = this.transactionsStore.getTransactionCount();
  filterTransSelect = {
    cssClass: 'filter-trans-select'
  };

  constructor(
    private datePipe: DatePipe,
    private platform: Platform,
    private location: Location,
    private alertService: AlertService,
    private auth: AuthenticationService,
    private cashiersStore: CashiersStore,
    private dashboardStore: DashboardStore,
    private transactionsStore: TransactionsStore,
    private closeOverlayService: CloseOverlayService
  ) {
    this.currentUser = this.auth.currentUserValue;
  }

  dismissModal() {
    this.alertService.dismissModal();
  }

  changeDate(ev: any) {
    const date = ev.detail.value;
    this.epochDateTime = new Date(date).getTime();
    this.todayDate = this.datePipe.transform(this.today, 'yyyy-MM-dd');
    this.pickerDate = this.datePipe.transform(this.epochDateTime, 'yyyy-MM-dd');

    const dateText = document.getElementById('date-text');
    const dateTextInner: HTMLElement =
      dateText.shadowRoot.querySelector('.datetime-text');
    dateTextInner.innerText = new Date(this.epochDateTime).toDateString(); // .slice(0, -4);
    this.dashboardStore.setIsDateChanged(true);
    this.dashboardStore.setPickerDate(this.pickerDate);
    if (this.todayDate === this.pickerDate) {
      dateTextInner.innerText = 'Today';
    } else {
      return;
    }
  }

  selectTransactionStatus(ev: any) {
    console.log(ev.target.value);
    const value = ev.target.value;
    if (value === 'all') {
      this.transactionStatus = '';
    } else if (value === 'received') {
      this.transactionStatus = '&completed=true';
    } else {
      this.transactionStatus = '&incomplete=true';
    }
  }

  selectPaymentMethod(ev: any) {
    const value = ev.target.value;
    console.log(value);
    if (value === 'all') {
      this.paymentMethod = '';
    } else if (value === 'bankTransfer') {
      this.paymentMethod = '&transfer=true';
    } else {
      this.paymentMethod = '&ussd=true';
    }
  }

  selectCashier(ev: any) {
    console.log(ev.target.value);
    this.cashierId = '&cashier=' + ev.target.value;
  }

  getTransactionTypeCount() {
    if (this.transactionDetails.length > 0) {
      this.transactionDetails.forEach((transactionDetail) => {
        if (transactionDetail.virtualAccount) {
          this.bankTransferCountArray.push(parseFloat(transactionDetail));
        }
        if (transactionDetail.ussdString) {
          this.ussdCountArray.push(parseFloat(transactionDetail));
        }
      });
      console.log(
        this.bankTransferCountArray.length,
        this.ussdCountArray.length
      );
      this.bankTransferCount = this.bankTransferCountArray.length;
      this.ussdCount = this.ussdCountArray.length;

      this.dashboardStore.setBankTransferCount(this.bankTransferCount);
      this.dashboardStore.setUssdCount(this.ussdCount);
    } else {
      this.bankTransferCount = '0';
      this.ussdCount = '0';

      this.dashboardStore.setBankTransferCount(this.bankTransferCount);
      this.dashboardStore.setUssdCount(this.ussdCount);
    }
  }

  getTransactions() {
    this.dismissModal();
    this.alertService.loading('Getting Transactions...');
    this.auth
      .getTransactions(
        this.pickerDate,
        20,
        this.offset,
        this.bankTransferCount,
        this.ussdCount,
        this.queryString
      )
      .subscribe(
        (response: any) => {
          this.alertService.stopLoading();
          console.log(response);
          this.transactionCount = response.count;
          this.transactionsStore.setTransactionCount(this.transactionCount);
          this.storeTransactionDetails(response.transaction);
          setTimeout(() => {
            this.getTransactionTypeCount();
            this.transactionsStore.setIsFilterApplied(true);
          }, 200);
        },
        (error) => {
          this.alertService.stopLoading();
          console.error(error);
        }
      );
  }

  storeTransactionDetails(response: any) {
    this.transactionsStore.setTransactionDetails(response);
    this.transactionDetails = this.transactionsStore.getTransactionDetails();
  }

  ionViewWillEnter() {
    this.offset = 0;
    this.bankTransferCount = '';
    this.ussdCount = '';

    const dateText = document.getElementById('date-text');
    const dateTextInner: HTMLElement =
      dateText.shadowRoot.querySelector('.datetime-text');
    dateTextInner.innerText = 'Today';
  }

  ionViewDidEnter() {
    this.subscription = this.platform.backButton.subscribeWithPriority(
      99999,
      () => {
        if (this.constructor.name === 'FilterTransactionsPage') {
          this.closeOverlayService.trigger();
        } else {
          this.location.back();
        }
      }
    );
  }

  ionViewDidLeave() {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    this.dashboardStore.setPickerDate(this.datePipe.transform(this.today, 'yyyy-MM-dd'));

    this.pickerDate = this.dashboardStore.getPickerDate();
    this.cashierId = '&cashier=all';
    this.transactionStatus = '';
    this.paymentMethod = '';
  }

  ngDoCheck(): void {
    this.queryString = this.transactionStatus.concat(
      this.paymentMethod + this.cashierId
    );
    this.transactionsStore.setFilterQueryString(this.queryString);
  }
}
